import { ROUTE_PATH as KKMS_PAGE_PATH } from '@/features/kkmsPage/consts';

export const ROUTE_PATH = `${KKMS_PAGE_PATH}/new`;

export const FEATURE_NAME = 'kkmCreatePage';
